import { memo, useCallback } from "react";

// UI
import { DatePicker } from "ui/components/DatePicker";
import { TextField } from "ui/components/TextField/TextField";

import { getStatusField } from "../fields";
import { VehicleStatusFieldsProps } from "../types";

/**
 * Nedostupno i Nedostupno – Dokumentacija. Ta dva statusa na backendu nemaju extender jer
 * ne nose nijedan povezani zapis — dovoljni su napomena i rok iz baznog zapisa. Zato ovdje
 * dijele komponentu; razlikuju se samo naslovi polja, koje daje konfiguracija
 * ("Razlog" odnosno "Koji dokument nedostaje").
 */
const VehicleStatusUnavailableFields: React.FC<VehicleStatusFieldsProps> = (props) => {
  const { status, values, errors, onChange } = props;

  const noteField = getStatusField(status, "note");
  const validUntilField = getStatusField(status, "validUntil");

  const handleTextChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
      const { name, value } = e.target;
      onChange({ [name]: value });
    },
    [onChange]
  );

  const handleDateChange = useCallback(
    (name: string, value: Date | null) => {
      onChange({ [name]: value });
    },
    [onChange]
  );

  // Razlog i rok idu jedno uz drugo — oba su kratka i čitaju se kao jedna rečenica:
  // zašto vozilo stoji i do kada.
  return (
    <div className="grid grid-cols-2 gap-3">
      {noteField && (
        <div>
          <TextField
            type="text"
            name="note"
            label={noteField.label}
            placeholder={noteField.label}
            value={values.note}
            onChange={handleTextChange}
            error={errors.note}
            required={noteField.required}
            width="full"
          />
        </div>
      )}

      {validUntilField && (
        <div>
          <DatePicker
            name="validUntil"
            label={validUntilField.label}
            placeholder={validUntilField.label}
            value={values.validUntil}
            onChange={handleDateChange}
            error={errors.validUntil}
            required={validUntilField.required}
            width="full"
          />
        </div>
      )}
    </div>
  );
};

export default memo(VehicleStatusUnavailableFields);
